var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFullLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1013.082,
    height: 576.823,
    viewBox: "0 0 1013.082 576.823",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6358",
    "data-name": "Group 6358",
    transform: "translate(-20844.418 2327.028)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Digital_Banking_Solution",
    "data-name": "Digital Banking Solution",
    transform: "translate(21421.5 -2131.499)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 1,
    fontSize: 110,
    fontFamily: "SFProDisplay-Heavy, SF Pro Display",
    fontWeight: 800
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Digital"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 132
  }, "Banking"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 264
  }, "Solution")), /*#__PURE__*/React.createElement("g", {
    id: "Group_6354",
    "data-name": "Group 6354",
    transform: "translate(10088.93 15831.934) rotate(-48)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_246",
    "data-name": "Ellipse 246",
    transform: "translate(20466 -3954.733)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 50
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 204.218,
    cy: 204.218,
    r: 204.218,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 204.218,
    cy: 204.218,
    r: 179.218,
    fill: "none"
  })), /*#__PURE__*/React.createElement("line", {
    id: "Line_132",
    "data-name": "Line 132",
    y2: 402.989,
    transform: "translate(20670.598 -3948.936)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 50
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_133",
    "data-name": "Line 133",
    x1: 188.859,
    transform: "translate(20677.248 -3750.323)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 50
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFullLogo);
export default __webpack_public_path__ + "static/media/full_logo.1be6a6a618e8544554c87312a1e43b80.svg";
export { ForwardRef as ReactComponent };